module.exports = __webpack_public_path__ + "static/srn-4-5a28a1751269f6c0c722973a33c42112.jpg";